import { render, staticRenderFns } from "./infinityScroll.vue?vue&type=template&id=5989556e&scoped=true&lang=pug"
import script from "./infinityScroll.vue?vue&type=script&lang=js"
export * from "./infinityScroll.vue?vue&type=script&lang=js"
import style0 from "./infinityScroll.vue?vue&type=style&index=0&id=5989556e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5989556e",
  null
  
)

export default component.exports